"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RADIUS = exports.PROJECTIONS = exports.METERS_PER_UNIT = exports.EXTENT = void 0;

var _Projection = _interopRequireDefault(require("./Projection.js"));

var _Units = _interopRequireDefault(require("./Units.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/proj/epsg4326
 */


/**
 * Semi-major radius of the WGS84 ellipsoid.
 *
 * @const
 * @type {number}
 */
var RADIUS = 6378137;
/**
 * Extent of the EPSG:4326 projection which is the whole world.
 *
 * @const
 * @type {import("../extent.js").Extent}
 */

exports.RADIUS = RADIUS;
var EXTENT = [-180, -90, 180, 90];
/**
 * @const
 * @type {number}
 */

exports.EXTENT = EXTENT;
var METERS_PER_UNIT = Math.PI * RADIUS / 180;
/**
 * @classdesc
 * Projection object for WGS84 geographic coordinates (EPSG:4326).
 *
 * Note that OpenLayers does not strictly comply with the EPSG definition.
 * The EPSG registry defines 4326 as a CRS for Latitude,Longitude (y,x).
 * OpenLayers treats EPSG:4326 as a pseudo-projection, with x,y coordinates.
 */

exports.METERS_PER_UNIT = METERS_PER_UNIT;

var EPSG4326Projection =
/** @class */
function (_super) {
  __extends(EPSG4326Projection, _super);
  /**
   * @param {string} code Code.
   * @param {string} [opt_axisOrientation] Axis orientation.
   */


  function EPSG4326Projection(code, opt_axisOrientation) {
    return _super.call(this, {
      code: code,
      units: _Units["default"].DEGREES,
      extent: EXTENT,
      axisOrientation: opt_axisOrientation,
      global: true,
      metersPerUnit: METERS_PER_UNIT,
      worldExtent: EXTENT
    }) || this;
  }

  return EPSG4326Projection;
}(_Projection["default"]);
/**
 * Projections equal to EPSG:4326.
 *
 * @const
 * @type {Array<import("./Projection.js").default>}
 */


var PROJECTIONS = [new EPSG4326Projection('CRS:84'), new EPSG4326Projection('EPSG:4326', 'neu'), new EPSG4326Projection('urn:ogc:def:crs:OGC:1.3:CRS84'), new EPSG4326Projection('urn:ogc:def:crs:OGC:2:84'), new EPSG4326Projection('http://www.opengis.net/def/crs/OGC/1.3/CRS84'), new EPSG4326Projection('http://www.opengis.net/gml/srs/epsg.xml#4326', 'neu'), new EPSG4326Projection('http://www.opengis.net/def/crs/EPSG/0/4326', 'neu')];
exports.PROJECTIONS = PROJECTIONS;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUdBOztBQUNBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBSkE7Ozs7O0FBTUE7Ozs7OztBQU1PLElBQU1BLE1BQU0sR0FBRyxPQUFmO0FBRVA7Ozs7Ozs7O0FBTU8sSUFBTUMsTUFBTSxHQUFHLENBQUMsQ0FBQyxHQUFGLEVBQU8sQ0FBQyxFQUFSLEVBQVksR0FBWixFQUFpQixFQUFqQixDQUFmO0FBRVA7Ozs7OztBQUlPLElBQU1DLGVBQWUsR0FBSUMsSUFBSSxDQUFDQyxFQUFMLEdBQVVKLE1BQVgsR0FBcUIsR0FBN0M7QUFFUDs7Ozs7Ozs7Ozs7QUFRQTtBQUFBO0FBQUE7RUFBaUNLO0VBQy9COzs7Ozs7RUFJQSw0QkFBWUMsSUFBWixFQUFrQkMsbUJBQWxCLEVBQXFDO1dBQ25DQyxrQkFBTTtNQUNKRixJQUFJLEVBQUVBLElBREY7TUFFSkcsS0FBSyxFQUFFQyxrQkFBTUMsT0FGVDtNQUdKQyxNQUFNLEVBQUVYLE1BSEo7TUFJSlksZUFBZSxFQUFFTixtQkFKYjtNQUtKTyxNQUFNLEVBQUUsSUFMSjtNQU1KQyxhQUFhLEVBQUViLGVBTlg7TUFPSmMsV0FBVyxFQUFFZjtJQVBULENBQU4sS0FRRTtFQUNIOztFQUNIO0FBQUMsQ0FoQkQsQ0FBaUNnQixzQkFBakM7QUFrQkE7Ozs7Ozs7O0FBTU8sSUFBTUMsV0FBVyxHQUFHLENBQ3pCLElBQUlDLGtCQUFKLENBQXVCLFFBQXZCLENBRHlCLEVBRXpCLElBQUlBLGtCQUFKLENBQXVCLFdBQXZCLEVBQW9DLEtBQXBDLENBRnlCLEVBR3pCLElBQUlBLGtCQUFKLENBQXVCLCtCQUF2QixDQUh5QixFQUl6QixJQUFJQSxrQkFBSixDQUF1QiwwQkFBdkIsQ0FKeUIsRUFLekIsSUFBSUEsa0JBQUosQ0FBdUIsOENBQXZCLENBTHlCLEVBTXpCLElBQUlBLGtCQUFKLENBQXVCLDhDQUF2QixFQUF1RSxLQUF2RSxDQU55QixFQU96QixJQUFJQSxrQkFBSixDQUF1Qiw0Q0FBdkIsRUFBcUUsS0FBckUsQ0FQeUIsQ0FBcEIiLCJuYW1lcyI6WyJSQURJVVMiLCJFWFRFTlQiLCJNRVRFUlNfUEVSX1VOSVQiLCJNYXRoIiwiUEkiLCJfX2V4dGVuZHMiLCJjb2RlIiwib3B0X2F4aXNPcmllbnRhdGlvbiIsIl9zdXBlciIsInVuaXRzIiwiVW5pdHMiLCJERUdSRUVTIiwiZXh0ZW50IiwiYXhpc09yaWVudGF0aW9uIiwiZ2xvYmFsIiwibWV0ZXJzUGVyVW5pdCIsIndvcmxkRXh0ZW50IiwiUHJvamVjdGlvbiIsIlBST0pFQ1RJT05TIiwiRVBTRzQzMjZQcm9qZWN0aW9uIl0sInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9wcm9qL2Vwc2c0MzI2LmpzIl0sInNvdXJjZXNDb250ZW50IjpbbnVsbF19